import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getApiClient } from '../api/apiClient';

const apiClient = getApiClient('kisanVani');

export function useStaffCommentReply(postId) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ parentPostCommentId, comment }) => {
      const response = await apiClient.post('/posts/comment', {
        postId,
        comment,
        parentPostCommentId,
      });
      if (!response.data?.success) {
        throw new Error(response.data?.message || 'Failed to post reply');
      }
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comments', postId] });
      queryClient.invalidateQueries({ queryKey: ['comments'] });
    },
  });
}
